import React from "react";
import { Chip, IconButton, Typography, CircularProgress, Dialog } from "@material-ui/core";
import { withRouter } from "react-router";
import { MapMarkerPopover, MapWrapper } from "./MapMarkerDetail.style";
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import classNames from 'classnames';

// import BIN from 'Assets/Images/BIN.png';
// import CFT from 'Assets/Images/CFT.png';
// import E_BIN from "Assets/Images/E_BIN.png";
// import RVM from 'Assets/Images/RVM.png';
// import SPECIAL_QR_CODE from 'Assets/Images/SPECIAL_QR_CODE.png';

// BIN IMAGES
import EDriveImg from 'Assets/Images/EDrive1.png'
//import ThreeIn1Img from 'Assets/Images/3-in-1 bin.png'
import ThreeIn1Img from 'Assets/Images/ICT1.png'
// import BatteryOnlyImg from 'Assets/Images/Battery-only bin.png'
import BatteryOnlyImg from 'Assets/Images/Battery1.png'
//import BbWithTubeImg from 'Assets/Images/BB bin with Fluorescent tub.png'
import BbWithTubeImg from 'Assets/Images/BatteryBulbTube1.png'
import BbImg from 'Assets/Images/Battery&Bulb1.png'
//import BbImg from 'Assets/Images/BB bin.png'
import DepotOnlyImg from 'Assets/Images/DepotDropOff1.png'
import MannedCollectionImg from 'Assets/Images/MannedCollection1.png'

import Api from "Helpers/ApiHandler";

const PopoverPosition = {
    TOP: "top",
    BOTTOM: "bottom",
    RIGHT: "right",
    LEFT: "left",
    CENTER: "center"
}
// const NAMES = {
//     BIN: "Bin",
//     E_BIN: "E-Bin",
//     RVM: "RVM",
//     CASH_FOR_TRASH: "CFT",
//     SPECIAL_QR_CODE: "Shoe Collection"
// }

// const IconImages = {
//     BIN: BIN,
//     E_BIN: E_BIN,
//     RVM: RVM,
//     CASH_FOR_TRASH: CFT,
//     SPECIAL_QR_CODE: SPECIAL_QR_CODE
// }

const E_BIN_NAMES = {
    "BB Bin": "Battery & Bulb Bin",
    "Battery Bin": "Battery Bin",
    "3 in 1 bin": "ICT, Battery & Bulb Bin",
    "E-Drive": "E-Drive",
    "depot-only": "Battery, Bulb & Tube",
    "Depot Drop Off": "Depot Drop Off",
    "Manned Collection": "Manned Collection"
}


const E_BinImages = {
    "E-Drive": EDriveImg,
    "3 in 1 bin": ThreeIn1Img,
    "Battery Bin": BatteryOnlyImg,
    "depot-only": BbWithTubeImg,
    "BB Bin": BbImg,
    "Depot Drop Off": DepotOnlyImg,
    "Manned Collection": MannedCollectionImg
}

class MapMarkerDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            anchorElement: null,
            anchorRef: null,
            isOpen: false,
            anchorPosition: {
                vertical: PopoverPosition.TOP,
                horizontal: PopoverPosition.CENTER
            },
            transformOrigin: {
                vertical: PopoverPosition.BOTTOM,
                horizontal: PopoverPosition.CENTER
            },
            currentPosition: PopoverPosition.TOP,
            showDetails: props.showDetails,
            isLoading: false,
            imageData: null,
            previewVisible: false,
            previewImage: "",
            imageIndex: 0
            // data: props.data
        }
    }


    getBinImage = async () => {
        this.setState({
            isLoading: true
        })
        await new Api().get(`bin/get-web-bin-image/${this.props.data.id}`).then(response => {
            if (response && response.data) {
                this.setState({
                    isLoading: false,
                    imageData: response.data.data
                })
            } else {
                this.setState({
                    isLoading: false
                })
            }
        }).catch(() => {
            this.setState({
                isLoading: false
            })
        });
    }

    handleMediaCancel = () => this.setState({ previewVisible: false });

    handleLeftArrow = () => {
        if (this.state.imageIndex === 0) {
            this.setState({
                imageIndex: this.state.imageData.bin_images.length - 1,
                previewImage: this.state.imageData.bin_images[this.state.imageData.bin_images.length - 1].url
            })
        }
        else {
            const newImageIndex = this.state.imageIndex - 1;
            this.setState({
                imageIndex: newImageIndex,
                previewImage: this.state.imageData.bin_images[newImageIndex].url
            })
        }

    }


    handleRightArrow = () => {
        let updated_index = this.state.imageData && this.state.imageData.bin_images && this.state.imageData.bin_images.length - 1;

        if (this.state.imageIndex === updated_index) {
            this.setState({
                imageIndex: 0,
                previewImage: this.state.imageData.bin_images[0].url
            })
        }
        else {
            const newImageIndex = this.state.imageIndex + 1;

            this.setState({
                imageIndex: newImageIndex,
                previewImage: this.state.imageData.bin_images[newImageIndex].url
            })
        }
    };

    openModal = (imageUrlIndex) => {
        this.setState({ previewVisible: true, imageIndex: imageUrlIndex, previewImage: this.state.imageData.bin_images[imageUrlIndex].url });
    }

    topPosition = () => {
        this.setState({
            anchorPosition: {
                vertical: PopoverPosition.TOP,
                horizontal: PopoverPosition.CENTER
            },
            transformOrigin: {
                vertical: PopoverPosition.BOTTOM,
                horizontal: PopoverPosition.CENTER
            },
            currentPosition: PopoverPosition.Top
        });
    }

    rightPosition = () => {
        this.setState({
            anchorPosition: {
                vertical: PopoverPosition.CENTER,
                horizontal: PopoverPosition.RIGHT
            },
            transformOrigin: {
                vertical: PopoverPosition.CENTER,
                horizontal: PopoverPosition.LEFT
            },
            currentPosition: PopoverPosition.RIGHT
        });
    }

    bottomPosition = () => {
        this.setState({
            anchorPosition: {
                vertical: PopoverPosition.BOTTOM,
                horizontal: PopoverPosition.CENTER
            },
            transformOrigin: {
                vertical: PopoverPosition.TOP,
                horizontal: PopoverPosition.CENTER
            },
            currentPosition: PopoverPosition.BOTTOM
        });
    }

    leftPosition = () => {
        this.setState({
            anchorPosition: {
                vertical: PopoverPosition.CENTER,
                horizontal: PopoverPosition.LEFT
            },
            transformOrigin: {
                vertical: PopoverPosition.CENTER,
                horizontal: PopoverPosition.RIGHT
            },
            currentPosition: PopoverPosition.LEFT
        })
    }
    handleAnchor = (event) => {
        if (!this.state.anchorElement) {

        }
        this.topPosition();
        if (event.clientY <= 115 || event.clientX <= 135) {
            this.rightPosition();
        }
        if (window.innerWidth - event.clientX <= 270 && event.clientY <= 115) {
            this.bottomPosition();
        }
        if (window.innerHeight - event.clientY <= 115 || window.innerWidth - event.clientX <= 135) {
            this.leftPosition();
        }
        // if (event.clientX <= 270 || event.clientY <= 58) {
        //     this.topPosition();
        // }

        this.setState({
            anchorElement: this.state.anchorElement ? null : event.currentTarget,
        });

        this.getBinImage()

    }

    handleCloseAnchor = () => {
        this.setState({
            anchorElement: null,
        });
    }

    render() {
        const { data } = this.props;

        const { imageData, isLoading } = this.state;

        const isOpen = Boolean(this.state.anchorElement);
        const id = isOpen ? 'simple-popover' : undefined;
        return (
            <>
                <MapWrapper>
                    <IconButton onClick={this.handleAnchor} disabled={!this.state.showDetails} >
                        <img
                            style={{
                                textAlign: "center",
                                transform: "translateZ(0) translate(-50%, -100%)",
                                position: "absolute"
                            }}
                            src={data && data.route_plan_id ? E_BinImages[data.route_plan_id] : require(`Assets/Images/map-pointer.png`)} alt=""
                            className={
                                classNames(
                                    'pin-icon',
                                    data.route_plan_id === '3 in 1 bin' && 'ict-bin',
                                    data.route_plan_id === 'Battery Bin' && 'batt-bin',
                                    data.route_plan_id === 'BB Bin' && 'bb-bin',
                                    data.route_plan_id === 'E-Drive' && 'e-drive-bin',
                                    data.route_plan_id === 'depot-only' && 'depot-only-bin',
                                    data.route_plan_id === 'Depot Drop Off' && 'depot-drop-off-bin',
                                    data.route_plan_id === 'Manned Collection' && 'manned-collection-bin'
                                )
                            }
                        />
                    </IconButton>
                    <MapMarkerPopover
                        className={`popover-class`}
                        id={id}
                        open={isOpen}
                        anchorEl={this.state.anchorElement}

                        anchorOrigin={{
                            vertical: this.state.anchorPosition.vertical,
                            horizontal: this.state.anchorPosition.horizontal,
                        }}
                        transformOrigin={{
                            vertical: this.state.transformOrigin.vertical,
                            horizontal: this.state.transformOrigin.horizontal,
                        }}
                        classes={{
                            paper: `popover-paper ${this.state.currentPosition === PopoverPosition.RIGHT && "popover-right"} 
                        ${this.state.currentPosition === PopoverPosition.BOTTOM && "popover-bottom"}
                        ${this.state.currentPosition === PopoverPosition.LEFT && "popover-left"}`
                        }}
                        onClose={this.handleCloseAnchor}
                    >

                        <div className={"popover-content flex f-column"}>
                            <div className={
                                classNames(
                                    'map-detail-header',
                                    data.route_plan_id === '3 in 1 bin' && 'three-bin',
                                    data.route_plan_id === 'Battery Bin' && 'battery-bin',
                                    data.route_plan_id === 'BB Bin' && 'battery-bulb-bin',
                                    data.route_plan_id === 'E-Drive' && 'e-drive',
                                    data.route_plan_id === 'depot-only' && 'depot-only',
                                    data.route_plan_id === 'Depot Drop Off' && 'depot-drop-off',
                                    data.route_plan_id === 'Manned Collection' && 'manned-collection'
                                )
                            } >
                                <Typography variant="body2" className="map-detail-title" component="p" gutterBottom noWrap>
                                    {E_BIN_NAMES[data.route_plan_id]}
                                </Typography>
                            </div>
                            <div className="map-detail-container full-height position-relative flex f-column">
                                {
                                    isLoading ? <div style={{ margin: "0 auto" }}><CircularProgress /></div> :
                                        <>
                                            <Chip size="small" label={(data.distance * 1.60934).toFixed(2) + " km"} className="map-details-distance-chip" />
                                            <Typography variant="body2" className="map-detail-sub-text block-with-text" color="textSecondary" component="p" gutterBottom >
                                                {data.address}
                                            </Typography>
                                            <div className="map-detail-button">
                                                {/* <SecondaryButton className="map-detail-project-button" onClick={this.openProjectDetail}>Project Detail</SecondaryButton> */}
                                            </div>
                                            <div className="flex">
                                                {imageData && imageData.description && <Typography variant="body2" className="map-detail-sub-text description-text" color="textSecondary" component="p" gutterBottom >
                                                    {(imageData && imageData.description) || ""}
                                                </Typography>}
                                                <div className="bin-images-container" >
                                                    {
                                                        (imageData && imageData.bin_images.length > 0) && (
                                                            <div className="bin-images-mini-container">
                                                                {
                                                                    imageData?.bin_images?.map((item, index) => (
                                                                        <img onClick={() => { this.openModal(index) }} key={index} src={item.url} alt="bin-content" className="bin-images" />
                                                                    ))
                                                                }

                                                            </div>

                                                        )
                                                    }
                                                    {/* {
                                                        (imageData && imageData.bin_images.length === 0) && (
                                                            <img src={imageData.bin_image} alt="bin" className="bin-image" />
                                                        )
                                                    } */}
                                                </div>
                                            </div>
                                        </>
                                }

                            </div>
                            {
                                this.state.previewVisible && this.state.previewImage &&
                                <Dialog open={this.state.previewVisible} footer={null} onClose={this.handleMediaCancel}>
                                    <div style={{ marginLeft: "auto" }}>
                                        <IconButton onClick={() => {
                                            this.setState({
                                                previewVisible: false
                                            })
                                        }} >
                                            <CloseIcon />
                                        </IconButton>
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <IconButton onClick={this.handleLeftArrow}>
                                            <KeyboardArrowLeftIcon style={{ height: "40px" }} />
                                        </IconButton>

                                        {
                                            // imageData?.bin_images?.map((item, index) => (
                                            //     <img onClick={this.openModal} key={index} src={item.url} alt="bin-content" style={{ width: "500px", height: "490px" }} />
                                            // ))
                                            this.state.previewImage && <img onClick={this.openModal} src={this.state.previewImage} alt="bin-content" style={{ width: "500px", height: "500px", padding: "1.5rem" }} />
                                        }

                                        <IconButton onClick={this.handleRightArrow}>
                                            <ChevronRightIcon style={{ height: "40px" }} />
                                        </IconButton>
                                    </div>
                                </Dialog>
                            }
                        </div>
                    </MapMarkerPopover>
                </MapWrapper>

            </>
        )
    }
}

export default withRouter(MapMarkerDetail);
